<template>
    <modal @close="closeFromModal">
        <h5 slot="header">{{ $tl("labels.routes.rwg") }}</h5>
        <div slot="body">
            <loader-component v-if="isLoading" />
            <form v-else id="rwg-opt-out-form" class="row" @submit.prevent="optOut">
                <div class="col-12">
                    <switch-input-component v-model="isChecked" :is-form-grid="false" required>
                        <template #label>
                            {{ $tl("questions.reserveWithGoogle.optOut", restaurantId) }}
                        </template>
                    </switch-input-component>
                </div>
            </form>
        </div>
        <div slot="footer" class="d-flex">
            <button type="button" class="modal-default-button btn btn-sm btn-secondary btn-circle" :disabled="isLoading" @click="close">
                {{ $tl("labels.form.actions.close", restaurantId) }}
            </button>
            <button type="submit" form="rwg-opt-out-form" class="btn btn-sm btn-success btn-circle ms-2" :disabled="isLoading">
                {{ $tl("labels.form.actions.accept", restaurantId) }}
            </button>
        </div>
    </modal>
</template>

<script>
import LoaderComponent from "../../LoaderComponent.vue";
import SwitchInputComponent from "../../forms/SwitchInputComponent.vue";

export default {
    data() {
        return {
            isLoading: false,
            isChecked: false,
        };
    },
    props: {
        restaurantId: {
            type: Number,
            required: true,
        },
    },
    methods: {
        optOut() {
            this.isLoading = true;

            this.httpPost(`/api/reserve_with_google/${this.restaurantId}/opt_out`, { checked: this.isChecked }).then((response) => {
                if (response !== false) {
                    this.$emit("opted-out");
                } else {
                    this.isLoading = false;
                }
            });
        },
        close() {
            this.$emit("close");
        },
        closeFromModal: function (e) {
            if (!e.target.classList.contains("modal-wrapper")) {
                e.stopPropagation();
            } else if (!this.isLoading) {
                this.close();
            }
        },
    },
    components: {
        LoaderComponent,
        SwitchInputComponent,
    },
};
</script>
